import { render, staticRenderFns } from "./Drug.vue?vue&type=template&id=67fdb3b0&scoped=true&lang=pug&"
import script from "./Drug.vue?vue&type=script&lang=ts&"
export * from "./Drug.vue?vue&type=script&lang=ts&"
import style0 from "./Drug.vue?vue&type=style&index=0&id=67fdb3b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fdb3b0",
  null
  
)

export default component.exports